import React from 'react'
import { makeStyles } from '@material-ui/styles'
import HandicapIcon from 'components/atoms/HandicapIcon'
import { map } from 'lodash'
import {
  HANDICAP_TYPE,
  ACCESSIBILITY_LEVEL,
} from '../../domains/cards/enums/handicaps'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    width: theme.spacing(45),
  },
  displayIcon: {
    flex: '0 0 25%',
    textAlign: '-webkit-center',
  },
}))

const generateAriaLabel = (handicaps) => {
  return (
    'Liste verticale des handicaps : ' +
    map(handicaps, (value, slug) => {
      const textHandicap = HANDICAP_TYPE[slug] || ''
      const textAccessibilityLevel = ACCESSIBILITY_LEVEL[value] || ''
      return `${textHandicap} : ${textAccessibilityLevel}`
    }).join('. ')
  )
}

const VerticalHandicapIconList = (props) => {
  const { handicaps } = props
  const classes = useStyles()

  return (
    <div
      className={classes.root}
      role="list"
      tabIndex={0}
      aria-label={generateAriaLabel(handicaps)}
    >
      {map(handicaps, (value, slug) => (
        <div key={slug} className={classes.displayIcon}>
          <HandicapIcon key={slug} value={value} slug={slug} tabIndex={-1} />
        </div>
      ))}
    </div>
  )
}

export default VerticalHandicapIconList
